





import displayStore from '@/store/modules/display/displayStore';
import { Component, Vue } from 'vue-property-decorator';
import mobile from 'is-mobile';

@Component({})
export default class MobileChecker extends Vue {
  public mounted(): void {
    window.addEventListener('resize', () => this.checkIsMobile());
    this.checkIsMobile();
  }

  private checkIsMobile(): void {
    const isMobile = mobile();
    displayStore.dispatch.setIsMobile(isMobile);
  }
}
